import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    AiFredConversationId} from "./conversation-id";
import {
    AiFredConversationIdZodSchema,
} from "./conversation-id";

type RemoveConversationCommand = {
    readonly _id: string;
    readonly _type: "REMOVE_CONVERSATION_COMMAND";
    readonly conversationId: AiFredConversationId;
};

type FactoryParams = Except<RemoveConversationCommand, "_id" | "_type">;
const removeConversationCommandFactory = (params: FactoryParams) => {
    const RemoveConversationCommand: RemoveConversationCommand = {
        ...params,
        _id: generateId({ prefix: "REMOVE_CONVERSATION_COMMAND__" }),
        _type: "REMOVE_CONVERSATION_COMMAND",
    };
    return RemoveConversationCommand;
};

const RemoveConversationCommandZodSchema: z.ZodSchema<RemoveConversationCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("REMOVE_CONVERSATION_COMMAND"),
        conversationId: AiFredConversationIdZodSchema,
    });

export { removeConversationCommandFactory, RemoveConversationCommandZodSchema };
export type {
    RemoveConversationCommand,
    FactoryParams as RemoveconversationCommandFactoryParams,
};
